import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_PAYOUT_ACCOUNT } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getLocalizedErrorMessage } from "../../utils/messageHelper";
import i18n from "../../i18n";

// API: POST /api/v1/payment/settlements/request
// body: { provider_type, order_type, payment_method, account_details, period_from?, period_to?, notes? }
export const submitSettlementRequestReducer = createAsyncThunk(
  ACTION_PAYOUT_ACCOUNT.submit_settlement_request,
  async (payload, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.submitSettlementRequest}`,
        { provider_type: "doctor", ...payload },
      );

      if (
        response?.data?.status === true ||
        response?.status === 200 ||
        response?.status === 201
      ) {
        toast.success(
          i18n.t(
            "withdraw.toast.request_submitted",
            "Withdrawal request submitted",
          ),
        );
        return response.data.data;
      }
      const message = getLocalizedErrorMessage({ response }, i18n);
      toast.error(message);
      return rejectWithValue(message);
    } catch (error) {
      console.error("Error submitting settlement request:", error);
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);
      return rejectWithValue(message);
    }
  },
);
